module.exports = __webpack_public_path__ + "img/log-in-icon.c30753f2.svg";